import useModal from 'hooks/useModal';
import { useTranslation } from 'react-i18next';
import { YardModel } from 'models/YardModel';
import useYards from 'modules/yards/hooks/useYards';
import YardDialog from 'modules/yards/dialogs/YardDialog';


const useYardModals = () => {
    const {t} = useTranslation();
    const {showModal, hideModal} = useModal();
    const {updateYard, createYard} = useYards();

    const openAddYardModal = (portId: number, isLoading: boolean) => showModal(YardDialog,
        {
            create: true,
            isLoading,
        },
        {
            title: t('add_title', {value: t('yard')}),
            maxWidth: 'md'
        })
        .then(yard => createYard({...yard, portId}))
        .then(hideModal);

    const openEditYardModal = (yard: YardModel) => showModal(YardDialog,
        {yard},
        {
            title: t('edit_title', {value: t('yard')}),
            maxWidth: 'md'
        })
        .then(yard => updateYard(yard))
        .then(hideModal);

    return {
        openAddYardModal,
        openEditYardModal,
    };
};

export default useYardModals;
